import moment from "moment";
import {
  GET_PRODUCTS,
  SET_PAGE,
  SET_SEARCH,
  SET_ORDER_BY,
  SET_SORT_BY,
  SET_COURSE_TYPE,
  SET_COURSES,
} from "../../shared/constants/ActionTypes";

const initialProducts = {
  products: [],
  productCount: 0,
  page: 1,
  search: "",
  courseType: "",
  // courseType: "FACE-TO-FACE",
  sortby: "",
  orderby: "desc",
  courses: [],
};

const productReducer = (state = initialProducts, action) => {
  switch (action.type) {
    case GET_PRODUCTS:
      return {
        ...state,
        products: action.payload.products.map((product) => {
          return {
            ...product,

            updatedAtFormatted: moment(product.createdAt).format("ll"),
            priceFormatted: `${product.directPrice} €`,
            comboPriceFormatted: product?.comboPrice
              ? `${product?.comboPrice} €`
              : "",
            categoryName: product.category?.categoryName,
            tutorName: product.tutor
              ? product.tutor?.firstName + " " + product.tutor?.lastName
              : null,
            startDateFormatted: product.courseStartDate
              ? moment(product.courseStartDate).format("ll")
              : null,
            endDateFormatted: product.courseEndDate
              ? moment(product.courseEndDate).format("ll")
              : null,

            // totalCourseDuration: `${product.totalCourseDuration} min`,
          };
        }),
        productCount: action.payload.totalCount,
      };

    case SET_PAGE:
      return {
        ...state,
        page: action.payload,
      };

    case SET_SEARCH:
      return {
        ...state,
        search: action.payload,
      };

    case SET_COURSE_TYPE:
      return {
        ...state,
        courseType: action.payload,
      };
    case SET_SORT_BY:
      return {
        ...state,
        sortby: action.payload,
      };
    case SET_ORDER_BY:
      return {
        ...state,
        orderby: action.payload,
      };
    case SET_COURSES:
      return {
        ...state,
        courses: action.payload,
      };

    default:
      return state;
  }
};

export default productReducer;
